<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        {{ workflowTemplateService.isCreateMode ? 'Create - Workflow Template' : workflowTemplateService.isViewMode ?
		'View - Workflow Template' : 'Edit - Workflow Template'}}
        <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content id="carousel-container">
    <input type="text" style="height:0px; width:0px; border:none;" />
    <div class="row auto-complete-equal com-doc-head eip-mt-10">
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <EIPAutoComplete WaterMarkText="Select Workflow Task" ShowTextValueField='N' floatLabelOption="never" TextField="WorkflowTaskDisplayText" ValueField="task_Id" setId="ddWfStatusEip" [dataSource]='workFlowStatusList' [SingleValueBind]="false" [defaultValue]="selectedTaskId" [IsDisabled]="!this.workFlowStatusList.length || workflowTemplateService.isCopyMode" [clearValue]='clearWfStatusSelected' (valueChange)='changeWorkflowStatus($event)' [IsCascading]='true'>
            </EIPAutoComplete>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div class="d-flex justify-content-end align-items-center" *ngIf="workflowTemplateService.isCreateMode">
                <div>
                    <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="workflowName"  ValueField="workflowId" WaterMarkText="Choose Template" [dataSource]='workflowTemplateList' [SingleValueBind]="false" setId="eipDDWorkflowId" (valueChange)='changeWorkflowTemplateList($event)' [IsCascading]='true'>
                    </EIPAutoComplete>
                </div>
                <span class="eip-pl-20 eip-pr-20"> | </span>
                <div>
                    <p class="eip-link">Preview & Choose Template</p>
                </div>
            </div>
            <div class="d-flex justify-content-end align-items-center" *ngIf="!workflowTemplateService.isCreateMode">
                <div>
                    <p class="eip-link"><i class="fa fa-line-chart fs-16 eip-link com-arrow " aria-hidden="true" id="btnCopy" title="Graphical View"></i></p>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-0 eip-pt-20">
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="dedDescription"  ValueField="dedId" WaterMarkText="IC" [dataSource]='icList' setId="ADWFddDiscpId7Ic" [defaultValue]="icid" [clearValue]='clearIcSelected' (valueChange)='changeIc($event)' [IsCascading]='true' [IsDisabled]="icIsDisabled || !workflowTemplateService.isCreateMode">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="dedDescription" ValueField="dedId" WaterMarkText="BU" [dataSource]='buList' setId="ADWFddDiscpId6Bu" [defaultValue]='buid' [clearValue]='clearBuSelected' (valueChange)='changeBu($event)' [IsCascading]='true' [IsDisabled]="!workflowTemplateService.isCreateMode">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" WaterMarkText="Project" TextField="projectDescription" [clearValue]='clearProjectSelected' ValueField="projectId" [defaultValue]='projectId' [dataSource]='projectList' setId="ADWFddMrlProjectId1810" (valueChange)='changeProject($event)' [IsCascading]='true' [IsDisabled]="projectIsDisabled || !workflowTemplateService.isCreateMode">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" WaterMarkText="Business Group" TextField="group_Name" [clearValue]='clearBusinessGrpSelected' ValueField="group_Id" [defaultValue]='businessGroupId' [dataSource]='businessGroupList' setId="ADWFddMrlBusGrpId21bg" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true' [IsDisabled]="!workflowTemplateService.isCreateMode">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
                <mat-label>Template name</mat-label>
                <input type="text" matInput [(ngModel)]="templateName" [disabled]="workflowTemplateService.isViewMode">
            </mat-form-field>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
                <mat-label>Template description</mat-label>
                <input type="text" matInput [(ngModel)]="templateDescription" [disabled]="workflowTemplateService.isViewMode">
            </mat-form-field>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="schType_Name" ValueField="schType_Id" WaterMarkText="Schedule Type" [dataSource]='scheduleTypeList' setId="ddDiscpId6Bu" [defaultValue]='scheduleTypeid' [clearValue]="clearValue" (valueChange)='changeScheduleType($event)' [IsCascading]='true' [IsDisabled]="workflowTemplateService.isViewMode">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field floatLabel="always" appearance="none">
                <mat-label>Is for Supersede</mat-label>
                <mat-slide-toggle color="primary" [(ngModel)]="isForsupersede" [disabled]="workflowTemplateService.isViewMode">
                </mat-slide-toggle>
                <textarea matInput hidden></textarea>
            </mat-form-field>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field floatLabel="always" appearance="none">
                <mat-label>Launch Reassign Member Pop-Up</mat-label>
                <mat-slide-toggle color="primary" [(ngModel)]="isForReAssignment" [disabled]="workflowTemplateService.isViewMode">
                </mat-slide-toggle>
                <textarea matInput hidden></textarea>
            </mat-form-field>
        </div>
    </div>
    <app-wftd-body-input (getInputValues)='getInputValues($event)' [TemplateDetails]='GetTemplateDetails()'></app-wftd-body-input>
    <app-wftd-bottom-kendo (changeWorkflowStatus)="changeWorkflowStatus($event)"></app-wftd-bottom-kendo>
</div>